module.exports = __webpack_public_path__ + "static/media/email-white.1c4aa352.svg";